<div class="container-fluid"  [ngClass]="{'bottom-padding': !parentComponentInput}">
  <div class="col-sm-11 center-block">
      <div class="row">
          <div class="col-md-6">
              <app-contact-detail #contactDetail [contactRevisionId]="contactRevisionId" [contactData]="contact" [parentComponentInput]="parentComponentInput" (cancelButtonClickedOutput)="cancelBtnClicked()" (contactOutput)="savedContact($event)" (contactRetrievedOutput)="contactRetrieved(contact)"></app-contact-detail>
          </div>
          <div class="col-md-5" [hidden]="isNewContact">
              <div class="card top-margin-40 pb-2">
                  <div class="card-header bg-primary">
                    <h3 class="card-title text-white" tabindex="0" aria-label="Associated companies" role="heading" aria-level="3">Associated companies</h3>
                  </div>
                  <div class="card-body p-0">
                      <div class="row">
                          <div class="col-sm-12">
                            <ejs-tooltip #tooltipCompany id="tooltipCompany" (beforeRender)="tooltipValue($event)"
                            target=".e-tooltipcolumn" [enableHtmlParse]="false">
                              <ejs-grid id='company_grid' #company_grid [dataSource]='company_grid_data' height="220"
                                        allowSorting='true' [pageSettings]='initialPage' [sortSettings]='sortOptions'
                                        allowPaging='true'
                                        [selectionSettings]="{ type: 'Single', checkboxMode: 'ResetOnRowClick' }"
                                        (rowSelecting)="company_grid.clearSelection()">
                                  <e-columns>
                                     <e-column [customAttributes]="clipmodecolumn" field='companyName' headerText='Company Name' clipMode="EllipsisWithTooltip" width='150'>
                                          <ng-template #template let-company_grid_data>
                                              <a class='pointer' *ngIf="!parentComponentInput; else modalTemplate"
                                              (click)='viewCompany(company_grid_data.companyRevisionId, company_grid_data.companyId)'
                                              role="link" aria-label="View Company" (keydown.enter)="viewCompany(company_grid_data.companyRevisionId, company_grid_data.companyId)" tabindex="0"
                                              >{{company_grid_data.companyName}}</a>

                                              <ng-template #modalTemplate>
                                                <label>{{company_grid_data.companyName}}</label>
                                              </ng-template>

                                          </ng-template>
                                      </e-column>
                                     <e-column [customAttributes]="clipmodecolumn" field='companyContactRoleDescription' headerText='Company Type' clipMode="EllipsisWithTooltip" placeholder="hi" title="hi" width='100'></e-column>
                                  </e-columns>
                              </ejs-grid>
                            </ejs-tooltip>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card top-margin-30" *ngIf="!parentComponentInput">
                  <div class="card-header bg-primary">
                      <h3 class="card-title text-white" tabindex="0" aria-label="Contact history" role="heading" aria-level="3">Contact history</h3>
                  </div>
                  <div class="card-body p-0">
                      <div class="row">
                          <div class="col-sm-12">
                            <ejs-tooltip #tooltipContact id="tooltipContact" (beforeRender)="tooltipValue($event)"
                            target=".e-tooltipcolumn" [enableHtmlParse]="false">
                              <ejs-grid #contactHistoryGrid id='contactHistoryGrid' [dataSource]='contactHistory_grid_data' height="240"
                                        allowSorting='true' [pageSettings]='initialPage' (queryCellInfo)='customizeCell($event)'
                                        allowPaging='true'
                                        [selectionSettings]="{ type: 'Single', checkboxMode: 'ResetOnRowClick' }"
                                        (rowSelecting)="contactHistoryGrid.clearSelection()">
                                  <e-columns>
                                     <e-column [customAttributes]="clipmodecolumn" field='contactName' headerText='Contact Name' clipMode="EllipsisWithTooltip" width='150'>
                                          <ng-template #template let-contactHistory_grid_data>
                                              <a class='pointer' (click)='viewContact(contactHistory_grid_data.contactRevisionId, contactHistory_grid_data.contactId)'
                                              role="link" aria-label="View Contact" (keydown.enter)="viewContact(contactHistory_grid_data.contactRevisionId, contactHistory_grid_data.contactId)" tabindex="0"
                                              >{{contactHistory_grid_data.contactName}}</a>
                                          </ng-template>
                                      </e-column>
                                     <e-column [customAttributes]="clipmodecolumn" field='version' headerText='Version' clipMode="EllipsisWithTooltip" width='100'></e-column>
                                  </e-columns>
                              </ejs-grid>
                            </ejs-tooltip>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-1"></div>
              </div>
          </div>
</div>
